import styled, { createGlobalStyle } from "styled-components";
import { tablet } from "styles/breakpoints";

export const GlobalStyle = createGlobalStyle`
  :root {
    --font-family-default: "Dosis", sans-serif;
  }

  body {
    scrollbar-gutter: stable;
    background-color: #f5f5f7;
  }

  * {
    font-family: var(--font-family-default);
  }
`;

export const PageContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  padding: 16px;
  box-sizing: border-box;

  @media (min-width: ${tablet}px) {
    padding: 24px;
  }
`;

export const ContentWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

export const CardsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  /* Add bottom padding to prevent sticky button from covering last card */
  padding-bottom: 100px;

  @media (min-width: ${tablet}px) {
    gap: 20px;
    padding-bottom: 120px;
  }
`;

export const CardSection = styled.section`
  width: 100%;
`;

export const ReviewedCounter = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 600;
  color: #6b6b76;
  padding: 0 4px;
`;

export const ReviewedEyeIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  color: #6b6b76;

  &::before {
    content: "";
    display: block;
    width: 18px;
    height: 18px;
    background: currentColor;
    mask-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Ccircle cx='12' cy='12' r='3' stroke='currentColor' stroke-width='2'/%3E%3C/svg%3E");
    mask-size: contain;
    mask-repeat: no-repeat;
    -webkit-mask-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Ccircle cx='12' cy='12' r='3' stroke='currentColor' stroke-width='2'/%3E%3C/svg%3E");
    -webkit-mask-size: contain;
    -webkit-mask-repeat: no-repeat;
  }
`;

export const SegmentBar = styled.div`
  display: flex;
  gap: 6px;
  padding: 0 4px;
`;

export const Segment = styled.button<{
  $color: string;
  $isViewed: boolean;
}>`
  flex: 1;
  height: 8px;
  border-radius: 4px;
  border: none;
  padding: 0;
  background: ${({ $isViewed, $color }) => ($isViewed ? $color : "#E0E0E0")};
  cursor: ${({ $isViewed }) => ($isViewed ? "pointer" : "default")};
  transition: background 0.3s ease;

  &:hover {
    ${({ $isViewed }) => $isViewed && "opacity: 0.8;"}
  }
`;

export const TilesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const BackToTopContainer = styled.div<{ $show?: boolean }>`
  position: fixed;
  bottom: 25px;
  left: 50%;
  transform: translateX(-50%);
  display: ${({ $show }) => ($show ? "flex" : "none")};
  justify-content: center;
  z-index: 100;

  && {
    button {
      background-color: rgba(255, 255, 255, 0.9);
      text-transform: none;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    }
  }
`;

export const HiddenPageHeading = styled.h1`
  position: absolute;
  left: -10000px;
  top: 0px;
`;
